export default (data) => ({
  type: 'OPEN_MODAL',
  payload: data,
});
